import { isEmpty } from 'bold-ui'
import { resolveName } from 'components/form'
import { RefObject, useCallback, useState } from 'react'
import { useForm } from 'react-final-form'
import { useHistory, useRouteMatch } from 'react-router'
import { metaPath } from 'util/metaPath'

import {
  hasAnyPerguntaData,
  setLastPerguntaToPreviousStatus,
} from '../consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import {
  CONSULTA_SEGUIMENTO_URL_MODAL,
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoModalTab,
} from '../model-consultaSeguimento'

interface UseConsultaSeguimentoModalProps {
  aplicarButtonRef: RefObject<HTMLButtonElement>
  valueInCache: ConsultaSeguimentoFieldModel
  onConfirmCloseModal: (handleConfirm: () => void) => void
}

const path = metaPath<ConsultaSeguimentoFieldModel>()

export function useConsultaSeguimentoModal(props: Readonly<UseConsultaSeguimentoModalProps>) {
  const { aplicarButtonRef, valueInCache, onConfirmCloseModal } = props

  const match = useRouteMatch()
  const history = useHistory()
  const { reset, getFieldState } = useForm<ConsultaSeguimentoFieldModel>()

  const hasValueInCache = !isEmpty(valueInCache)

  const [currentTab, setCurrentTab] = useState<ConsultaSeguimentoModalTab>(
    hasValueInCache ? ConsultaSeguimentoModalTab.RESULTADO : ConsultaSeguimentoModalTab.SELECAO
  )

  const goBack = useCallback(() => {
    history.push(match.url.split(CONSULTA_SEGUIMENTO_URL_MODAL)[0])
    setTimeout(() => aplicarButtonRef?.current?.focus())
  }, [aplicarButtonRef, history, match.url])

  const handleCloseModal = useCallback(() => {
    const isPerguntaSelecionadasModified = getFieldState(resolveName(path.perguntasSelecionadas))?.modified
    const anyPerguntaFromAplicacaoHasData = hasAnyPerguntaData(getFieldState(resolveName(path.aplicacao)).value)

    const showConfirmDialog =
      currentTab === ConsultaSeguimentoModalTab.APLICACAO ||
      (currentTab === ConsultaSeguimentoModalTab.SELECAO &&
        (isPerguntaSelecionadasModified || anyPerguntaFromAplicacaoHasData))

    if (showConfirmDialog) {
      onConfirmCloseModal(goBack)
    } else {
      goBack()
    }
  }, [currentTab, getFieldState, goBack, onConfirmCloseModal])

  const handleGoToSelecao = useCallback(() => {
    setCurrentTab(ConsultaSeguimentoModalTab.SELECAO)
  }, [])

  const handleGoToAplicacao = useCallback(() => {
    setCurrentTab(ConsultaSeguimentoModalTab.APLICACAO)
  }, [])

  const handleGoBackToAplicacao = useCallback(() => {
    reset({ ...valueInCache, aplicacao: setLastPerguntaToPreviousStatus(valueInCache.aplicacao) })
    handleGoToAplicacao()
  }, [handleGoToAplicacao, reset, valueInCache])

  const handleGoToResultado = useCallback(() => {
    setCurrentTab(ConsultaSeguimentoModalTab.RESULTADO)
  }, [])

  return {
    currentTab,
    handleGoToSelecao,
    handleGoToAplicacao,
    handleGoBackToAplicacao,
    handleGoToResultado,
    handleCloseModal,
  }
}
